export const EVENT = 'eventTypeId';
export const APPLICATION = 'appId';
export const NETWORK = 'netId';
export const AFFILIATES = 'affiliateIds';
export const CAMPAIGNS = 'adCampaignIds';
export const REG_PLATFORM = 'regActionPlatformId';
export const RE_PLATFORM = 'rePlatformId';
export const EVENT_PLATFORM = 'platformId';
export const TRAFFIC_TYPE = 'trafficTypeId';
export const REGISTRATION_COUNTRIES = 'regActionCountryIds';
export const EVENT_COUNTRIES = 'eventCountryIds';
export const CHANNELS = 'excludedAffiliateChannelIds';

export const TRAFFIC_TYPE_ALL = 1;
export const TRAFFIC_TYPE_AFFILIATES = 2;

export const ACTIVITY_TYPE_ALL = 1;
export const ACTIVITY_TYPE = 'activityTypeId';

export const IS_INCLUDE_REJECTED_REGS = 'includeRejected';

export const CONVERSION_INFO = 'conversionInfo';
export const PROVIDER_TYPE = 'providerTypeId';

export const SENDING_DELAY = 'sendingDelay';

export const IS_ACTIVE = 'enabled';

export const DEPENDENCIES = {};
